export * from './label-demo.component';
